var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.065 7.985a.85.85 0 11-1.203-1.202L9.398.25a.85.85 0 011.202 0l6.535 6.534a.85.85 0 11-1.203 1.202l-5.083-5.083v9.71a.85.85 0 01-1.7 0v-9.71L4.065 7.985zM1.7 15.226a.85.85 0 10-1.7 0v1.307a3.464 3.464 0 003.464 3.464h13.069a3.464 3.464 0 003.463-3.464v-1.307a.85.85 0 10-1.7 0v1.307c0 .974-.79 1.764-1.763 1.764H3.463c-.973 0-1.763-.79-1.763-1.764v-1.307z",
    fill: "currentColor"
  })));
}
export default SvgShare;